import React from 'react';
import Typography from '@mui/material/Typography';
import {Box, InputAdornment} from '@mui/material';
import PropTypes from 'prop-types';
import {validateFieldLength} from '../../../utility/validationUtil';
import AdmicityForm from '../../../shared-components/AdmicityForm';

const validateDFENumber = (value) => {
    const isValid = /^\d{3}\d{4}$/.test(value);
    return {
        isValid,
        message: isValid ? '' : 'DFE number must be in the format: 3 digits for authority and 4 digits for school number',
    };
};

const validateWebDomain = (value) => {
    const isValid = /^([a-zA-Z0-9][a-zA-Z0-9-_]*\.)*[a-zA-Z0-9]*[a-zA-Z0-9-_]*[[a-zA-Z0-9]+$/.test(value);
    return {
        isValid,
        message: isValid ? '' : 'Enter a domain (e.g., hogwarts.admicity.co.uk)',
    };
};

const SchoolSetupForm = ({editMode, schoolInfo, onSubmit}) => {

    const handleSubmit = (payload) => {
        const body =
            !editMode
                ? {
                    name: payload.name,
                    dfeNumber: payload.dfeNumber,
                    subDomain: payload.domain,
                    domain: process.env.REACT_APP_DOMAIN,
                    notes: payload.notes,
                    registrationInviteConfigOption: payload.registrationInviteConfigOption,
                    emailAddresses: payload.emailAddresses
                }
                : {
                    id: schoolInfo.id,
                    name: payload.name,
                    dfeNumber: payload.dfeNumber,
                    notes: payload.notes,
                    registrationInviteConfigOption: payload.registrationInviteConfigOption,
                    emailAddresses: payload.emailAddresses
                };

        onSubmit(body);
    };

    const textFields = [
        {
            label: 'School Name',
            name: 'name',
            initialValue: schoolInfo.name,
            validate: (value) => validateFieldLength(value, 400)
        },
        {
            label: 'DFE Number',
            name: 'dfeNumber',
            initialValue: schoolInfo.dfeNumber,
            validate: validateDFENumber
        },
        {
            label: 'School Web Domain at Admicity',
            name: 'domain',
            initialValue: schoolInfo.domain,
            helperText: 'Enter a domain (e.g., hogwarts.admicity.co.uk)',
            disabled: editMode,
            InputProps: (!editMode
                ? {
                    endAdornment: (
                        <InputAdornment position="end">
                            <Typography>{process.env.REACT_APP_DOMAIN}</Typography>
                        </InputAdornment>
                    ),
                }
                : {}),
            validate: validateWebDomain
        },
        {
            label: 'Email addresses to send information about profiles changes',
            name: 'emailAddresses',
            required: false,
            initialValue: schoolInfo.emailAddresses,
        },
        {
            label: 'Notes',
            name: 'notes',
            initialValue: schoolInfo.notes,
            multiline: true,
            rows: 4,
            required: false
        }
    ];

    return (
        <Box
            display="flex"
            flexDirection="column"
            sx={{
                width: {
                    xs: '100%',
                    sm: '75%',
                    md: '50%',
                    lg: '50%',
                },
            }}
        >
            <AdmicityForm
                textFields={textFields}
                handleSubmit={handleSubmit}
                buttonText="Save"
                actionsContainerProps={{
                    container: {
                        justifyContent: 'flex-end'
                    },
                    button: {
                        fullWidth: false
                    }
                }}
            />
        </Box>
    );
};

SchoolSetupForm.defaultProps = {
    editMode: false
};

SchoolSetupForm.propTypes = {
    editMode: PropTypes.bool,
    schoolInfo: PropTypes.object,
    onSubmit: PropTypes.func
};

export default SchoolSetupForm;